import {SpanIcon} from '@mazraeapp/react_icon_kit';
import React from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';

function DeleteStoryBS({
  setIsOpen,
  open,
  guid,
  handler,
}: {
  setIsOpen: () => void;
  open: boolean;
  guid: string | null;
  handler: (id: string) => void;
}) {
  return (
    <BottomSheet
      onDismiss={setIsOpen}
      open={open}
      blocking={true}
      className="custom-bottom-sheet"
    >
      <div className="flex flex-col gap-4 p-6 text-sm text-gray-900">
        <div className="flex items-center justify-between text-md font-medium">
          <span>حذف استوری</span>
          <SpanIcon
            className="icon-nameClose-remove text-2xl"
            onClick={setIsOpen}
          />
        </div>
        <p>آیا می‌خواهید استوری خود را حذف کنید؟</p>
        <div className="flex items-center gap-4">
          <button
            onClick={setIsOpen}
            className="border-[1px] border-solid border-red-600 text-red-600 flex-1 py-2.5 px-3 rounded-lg"
          >
            انصراف
          </button>
          <button
            className="bg-farm-shop-500 text-white flex-1 py-2.5 px-3 rounded-lg"
            onClick={() => handler(guid || '')}
          >
            حذف استوری
          </button>
        </div>
      </div>
    </BottomSheet>
  );
}

export default DeleteStoryBS;
